export enum Routing {
  HOME = '/',
  SETTINGS = '/settings',
  PROCESS = '/process',
  SUBPROCESS = '/sub-process',
  EDIT_FORM = '/edit-form',
  CONFIG_FORM = '/config-form',
  LOGIN = '/login',
}
